import MainLayout from "../../themes/layouts/Main";
import UsersList from "../../components/Users/List";

const UsersListRoute: React.FC = () => {
  return (
    <MainLayout>
      <UsersList />
    </MainLayout>
  );
};

export default UsersListRoute;
